const isCrawlerUserAgent = () => {
  if (typeof navigator.userAgent !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase();

    for (let i = 0; i < crawlerUserAgents.length; i++) {
      const crawlerRegex = new RegExp(crawlerUserAgents[i], 'i'); // force case insensitive match
      if (crawlerRegex.test(userAgent)) {
        // eslint-disable-next-line no-console
        console.warn(`${crawlerUserAgents[i]} crawler user agent detected`);
        return true;
      }
    }
  }

  return false;
};

export default isCrawlerUserAgent;

// Just the relevant `pattern` keys from https://raw.githubusercontent.com/monperrus/crawler-user-agents/master/crawler-user-agents.json
// Full JSON is 176KB while this is only 9KB
const crawlerUserAgents = [
  "Jamie's Spider",
  '(^| )PTST',
  '(^| )sentry',
  '(sistrix|SISTRIX) [cC]rawler',
  '007ac9 Crawler',
  '2ip bot',
  '2ip.ru',
  '360Spider',
  '[cC]laude[bB]ot',
  '[Cc]urebot',
  '[pP]ingdom',
  '[wW]get',
  '^Apache-HttpClient',
  '^BW',
  '^curl',
  '^LCC ',
  '^PHP-Curl-Class',
  'A Patent Crawler',
  'A6-Indexer',
  'Aboundex',
  'AcademicBotRTU',
  'acapbot',
  'acoonbot',
  'adbeat_bot',
  'AddSearchBot',
  'AddThis',
  'Adidxbot',
  'ADmantX',
  'AdsBot-Google([^-]|$)',
  'AdsBot-Google-Mobile',
  'adscanner',
  'AdsTxtCrawler',
  'AdvBot',
  'AHC',
  'Ahrefs(Bot|SiteAudit)',
  'aiHitBot',
  'aiohttp',
  'AISearchBot',
  'AlexandriaOrgBot',
  'AlphaBot',
  'Amazon CloudFront',
  'Amazonbot',
  'AndersPinkBot',
  'antibot',
  'AnyEvent',
  'Apercite',
  'APIs-Google',
  'AppEngine-Google',
  'AppInsights',
  'Applebot',
  'arabot',
  'archive.org_bot',
  'ArchiveBot',
  'AspiegelBot',
  'Atom Feed Robot',
  'Audisto Crawler',
  'AwarioBot',
  'AwarioRssBot',
  'AwarioSmartBot',
  'awesomecrawler',
  'axios',
  'B2B Bot',
  'backlinkcrawler',
  'Baidu-YunGuanCe',
  'Baiduspider',
  'Bark[rR]owler',
  'BazQux',
  'BDCbot',
  'BehloolBot',
  'betaBot',
  'Better Uptime Bot',
  'bidswitchbot',
  'BIGLOTRON',
  'bingbot',
  'BingPreview',
  'binlar',
  'BitBot',
  'bitlybot',
  'BitSightBot',
  'Blackboard',
  'BLEXBot',
  'blogmuraBot',
  'BlogTraffic/d.d+ Feed-Fetcher',
  'BLP_bbot',
  'bnf.fr_bot',
  'BomboraBot',
  'bot-pge.chlooe.com',
  'Bot.AraTurka.com',
  'botify',
  'BoxcarBot',
  'brainobot',
  'BrandONbot',
  'BrandVerity',
  'BrightEdge Crawler',
  'BTWebClient',
  'BUbiNG',
  'BublupBot',
  'Buck',
  'buzzbot',
  'Bytespider',
  'Caliperbot',
  'CapsuleChecker',
  'careerbot',
  'CC Metadata Scaper',
  'CCBot',
  'centurybot',
  'changedetection',
  'ChatGPT-User',
  'check_http',
  'CheckMarkNetwork',
  'Chrome-Lighthouse',
  'Cincraw',
  'CISPA Webcrawler',
  'citeseerxbot',
  'Clickagy',
  'Cliqzbot',
  'CloudFlare-AlwaysOnline',
  'Cloudflare-Healthchecks',
  'CloudFlare-Prefetch',
  'Cloudflare-SSLDetector',
  'Cloudflare-Traffic-Manager',
  'coccoc',
  'Cocolyzebot',
  'collection@infegy.com',
  'Companybook-Crawler',
  'content crawler spider',
  'ContextAd Bot',
  'contxbot',
  'convera',
  'Cookiebot',
  'CookieHubScan',
  'crawler4j',
  'CrawlyProjectCrawler',
  'CriteoBot',
  'CrunchBot',
  'CrystalSemanticsBot',
  'Cutbot',
  'cXensebot',
  'CyberPatrol',
  'DareBoost',
  'Datafeedwatch',
  'DataForSeoBot',
  'datagnionbot',
  'Datanyze',
  'Dataprovider.com',
  'Daum',
  'dcrawl',
  'deadlinkchecker',
  'deepnoc',
  'DeuSu',
  'developers.google.com/+/web/snippet',
  'Diffbot',
  'Digg Deeper',
  'Digincore bot',
  'discobot',
  'Discordbot',
  'Disqus',
  'DnyzBot',
  'Domain Re-Animator Bot',
  'domaincrawler',
  'Domains Project',
  'DomainStatsBot',
  'dotbot',
  'Dragonbot',
  'drupact',
  'Dubbotbot',
  'DuckAssistBot',
  'DuckDuckBot',
  'DuckDuckGo-Favicons-Bot',
  'e.ventures Investment Crawler',
  'ec2linkfinder',
  'edisterbot',
  'electricmonk',
  'elisabot',
  'Embedly',
  'epicbot',
  'eright',
  'europarchive.org',
  'ev-crawler',
  'evc-batch',
  'EveryoneSocialBot',
  'exabot',
  'Expanse',
  'Experibot',
  'ExtLinksBot',
  'Eyeotabot',
  'EZID',
  'ezooms',
  'facebookcatalog',
  'facebookexternalhit',
  'Facebot',
  'FAST Enterprise Crawler',
  'FAST-WebCrawler',
  'fedoraplanet',
  'Feedbin',
  'feedbot',
  'Feedfetcher-Google',
  'Feedly',
  'Feedspot',
  'FeedValidator',
  'FemtosearchBot',
  'Fetch',
  'Fever',
  'filterdb.iss.net/crawler',
  'FindITAnswersbot',
  'findlink',
  'findthatfile',
  'findxbot',
  'Flamingo_SearchEngine',
  'FlipboardProxy',
  'fluffy',
  'fr-crawler',
  'FreeWebMonitoring SiteChecker',
  'FreshpingBot',
  'FreshRSS',
  'Friendica',
  'fuelbot',
  'Fyrebot',
  'g00g1e.net',
  'G2 Web Services',
  'g2reader-bot',
  'GarlikCrawler',
  'GeedoBot',
  'Genieo',
  'Gigablast',
  'Gigabot',
  'GingerCrawler',
  'Gluten Free Crawler',
  'gnam gnam spider',
  'GnowitNewsbot',
  'Go-http-client',
  'Google Favicon',
  'Google Web Preview',
  'Google-Adwords-Instant',
  'Google-Certificates-Bridge',
  'Google-InspectionTool',
  'Google-PhysicalWeb',
  'Google-Read-Aloud',
  'Google-Safety',
  'Google-Site-Verification',
  'Google-Structured-Data-Testing-Tool',
  'google-xrawler',
  'Googlebot',
  'Googlebot-Image',
  'Googlebot-Mobile',
  'Googlebot-News',
  'Googlebot-Video',
  'GoogleOther',
  'Gowikibot',
  'GPTBot',
  'GrapeshotCrawler',
  'Grobbot',
  'GroupHigh',
  'GroupMeBot',
  'grub.org',
  'gslfbot',
  'Gwene',
  'HanaleiBot',
  'Hatena',
  'HeadlessChrome',
  'heritrix',
  'HTTP Banner Detection',
  'http_get',
  'https://developers.cloudflare.com/security-center',
  'httpunit',
  'HttpUrlConnection',
  'httpx',
  'HTTrack',
  'HubSpot',
  'Hydrozen.io',
  'hypestat',
  'hyscore.io',
  'ia_archiver',
  'IAS crawler',
  'ICBot',
  'ICC-Crawler',
  'ichiro',
  'Iframely',
  'ImagesiftBot',
  'imrbot',
  'IndeedBot',
  'INETDEX-BOT',
  'infoobot',
  'inoreader',
  'integromedb',
  'intelium_bot',
  'InterfaxScanBot',
  'InternetMeasurement',
  'IonCrawl',
  'ip-web-crawler.com',
  'ips-agent',
  'iskanie',
  'IstellaBot',
  'it2media-domain-crawler',
  'James BOT',
  'Jetslide',
  'Jetty',
  'JobboerseBot',
  'Jooblebot',
  'jpg-newsbot',
  'Jugendschutzprogramm-Crawler',
  'jyxobot',
  'K7MLWCBot',
  'Kemvibot',
  'KeybaseBot',
  'KomodiaBot',
  'KosmioBot',
  'KStandBot',
  'Landau-Media-Spider',
  'Laserlikebot',
  'lb-spider',
  'Leikibot',
  'Lemmy',
  'libwww-perl',
  'LightspeedSystemsCrawler',
  'Linespider',
  'Linguee Bot',
  'linkapediabot',
  'LinkArchiver',
  'linkdex',
  'LinkedInBot',
  'LinkisBot',
  'lipperhey',
  'Livelap[bB]ot',
  'lkxscan',
  'lssbot',
  'lssrocketcrawler',
  'ltx71',
  'Luminator-robots',
  'MaCoCu',
  'magpie-crawler',
  'Mail.RU_Bot',
  'mappydata',
  'Mastodon',
  'MauiBot',
  'MBCrawler',
  'Mediapartners (Googlebot)',
  'Mediapartners-Google',
  'Mediatoolkitbot',
  'MegaIndex',
  'MeltwaterNews',
  'memorybot',
  'meta-externalads',
  'meta-externalagent',
  'meta-externalfetcher',
  'MetaInspector',
  'MetaJobBot',
  'MetaURI',
  'MicrosoftPreview',
  'mindUpBot',
  'minicrawler',
  'Miniflux',
  'MixnodeCache',
  'MJ12bot',
  'mlbot',
  'moatbot',
  'MojeekBot',
  'Monsidobot',
  'MoodleBot',
  'Moreover',
  'msnbot',
  'msrbot',
  'MTRobot',
  'MuckRack',
  'Multiviewbot',
  'NAVER Blog Rssbot',
  'Neevabot',
  'NerdByNature.Bot',
  'nerdybot',
  'NetcraftSurveyAgent',
  'netEstate NE Crawler',
  'Neticle Crawler',
  'netresearchserver',
  'NetSystemsResearch',
  'Netvibes',
  'NewsBlur',
  'newsharecounts',
  'newspaper',
  'NextCloud',
  'Nicecrawler',
  'niki-bot',
  'Nimbostratus-Bot',
  'NING',
  'NINJA bot',
  'NIXStatsbot',
  'Nmap Scripting Engine',
  'node-fetch',
  'NTENTbot',
  'Nutch',
  'Nuzzel',
  'OAI-SearchBot',
  'Ocarinabot',
  'OdklBot',
  'officestorebot',
  'okhttp',
  'omgili',
  'online-webceo-bot',
  'OpenGraphCheck',
  'OpenHoseBot',
  'openindexspider',
  'OrangeBot',
  'outbrain',
  'OutclicksBot',
  'page2rss',
  'PagePeeker',
  'PageThing',
  'Pandalytics',
  'panscient',
  'PaperLiBot',
  'Pcore-HTTP',
  'PerplexityBot',
  'PetalBot',
  'PhantomJS',
  'phpcrawl',
  'PhxBot',
  'pinterest.com/bot',
  'PiplBot',
  'PocketParser',
  'postrank',
  'PR-CY.RU',
  'Primalbot',
  'PrivacyAwareBot',
  'proximic',
  'psbot',
  'Pulsepoint',
  'purebot',
  'python-opengraph',
  'python-requests',
  'Python-urllib',
  'Qwantify',
  'RankActiveLinkBot',
  'redditbot',
  'Refindbot',
  'RegionStuttgartBot',
  'RetrevoPageAnalyzer',
  'ReverseEngineeringBot',
  'RidderBot',
  'Rivva',
  'rogerbot',
  'rssbot',
  'RSSingBot',
  'RuxitSynthetic',
  'RyteBot',
  'S[eE][mM]rushBot',
  'SafeDNSBot',
  'SafeSearch microdata crawler',
  'SBL-BOT',
  'ScoutJet',
  'Scrapy',
  'Screaming Frog SEO Spider',
  'scribdbot',
  'search.marginalia.nu',
  'SearchAtlas',
  'seekbot',
  'Seekport',
  'seewithkids',
  'semanticbot',
  'SemanticScholarBot',
  'sempi.tech',
  'semrush.com',
  'SentiBot',
  'SenutoBot',
  'SeobilityBot',
  'SEOkicks',
  'SEOlizer',
  'seoscanners',
  'seostar.co',
  'SerendeputyBot',
  'serpstatbot',
  'SeznamBot',
  'SimpleCrawler',
  'SimplePie',
  'SimpleScraper',
  'siteauditbot',
  'sitebot',
  'SiteCheckerBotCrawler',
  'siteexplorer.info',
  'Siteimprove.com',
  'SkypeUriPreview',
  'Slack-ImgProxy',
  'Slackbot',
  'Slurp',
  'smtbot',
  'Snacktory',
  'Snap URL Preview Service',
  'SocialRankIOBot',
  'Sogou',
  'Sonic',
  'spbot',
  'speedy',
  'startmebot',
  'Storebot-Google',
  'StorygizeBot',
  'StractBot',
  'Streamline3Bot',
  'SummalyBot',
  'summify',
  'Superfeedr',
  'SurdotlyBot',
  'SurveyBot',
  'SWIMGBot',
  'Synapse',
  'Sysomos',
  't3versionsBot',
  'Taboolabot',
  'tagoobot',
  'TangibleeBot',
  'TelegramBot',
  'Teoma',
  'theoldreader.com',
  'Thinklab',
  'tigerbot',
  'TinEye',
  'Tiny Tiny RSS',
  'TombaPublicWebCrawler',
  'toplistbot',
  'ToutiaoSpider',
  'Traackr.com',
  'tracemyfile',
  'trendictionbot',
  'TrendsmapResolver',
  'Trove',
  'trovitBot',
  'Turnitin',
  'tweetedtimes',
  'TweetmemeBot',
  'twengabot',
  'Twingly',
  'Twitterbot',
  'Twurly',
  'um-LN',
  'Upflow',
  'Uptime-Kuma',
  'Uptimebot.org',
  'UptimeRobot',
  'urlappendbot',
  'UsineNouvelleCrawler',
  'UT-Dorkbot',
  'Validator.nu',
  'Valve/Steam',
  'vebidoobot',
  'VelenPublicWebCrawler',
  'Veoozbot',
  'vercel-screenshot',
  'Vercelbot',
  'Viber',
  'Vigil',
  'virustotal',
  'VKRobot',
  'vkShare',
  'voilabot',
  'VoluumDSP-content-bot',
  'vuhuvBot',
  'W3C-checklink',
  'W3C-mobileOK',
  'W3C_CSS_Validator',
  'W3C_I18n-Checker',
  'W3C_Unicorn',
  'W3C_Validator',
  'wbsearchbot',
  'web-archive-net.com.bot',
  'webcompanycrawler',
  'WebDataStats',
  'webmon ',
  'WellKnownBot',
  'WeSEE:Search',
  'WhatsApp',
  'wocbot',
  'woobot',
  'woorankreview',
  'WordPress',
  'WordupInfoSearch',
  'woriobot',
  'wotbox',
  'www.uptime.com',
  'Xenu Link Sleuth',
  'xovibot',
  'Y!J',
  'yacybot',
  'Yahoo Link Preview',
  'YaK',
  'yandex.com/bots',
  'YandexRenderResourcesBot',
  'yanga',
  'Yellowbrandprotectionbot',
  'Yeti',
  'YisouSpider',
  'yoozBot',
  'YouBot',
  'Zabbix',
  'zenback bot',
  'zgrab',
  'ZoomBot',
  'ZoominfoBot',
  'ZumBot',
  'ZuperlistBot',
];
